
<div class="container-fluid" style="--bs-gutter-x: 1.5rem; --bs-gutter-y 0 : 0; width: 100%; padding-right: calc(var(--bs-gutter-x) * .5); padding-left: calc(var(--bs-gutter-x) * .5); margin-right: auto; margin-left: auto;">
  <div style="background-color:#dc3545;color: white;text-align: center;padding: 20px;"><h1>Invitation for Expression of Interest (EoI)</h1></div>
  <div class="container p-4 bg-white rounded" style="border-radius: var(--bs-border-radius) !important; --bs-bg-opacity: 1; background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important; padding: 1.5rem !important; max-width: 1320px; ">
    <form [formGroup]="form">

      <h5 style="background-color: #dc3545; color: #fff; padding: 7px; border-radius: 5px;">1. Enterprise Details</h5>
      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">
        <div class="col-md-4" style=" flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Udyam Registration Number  <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" autocomplete="off" formControlName="UdyamRegistrationNumber" trimValue id="txtUdyamRegistrationNumber" class="form-control"
                 name="UdyamRegistrationNumber" readonly maxlength="19" style="background-color: #e9ecef; color: #6c757d;" />
          <div *ngIf="f['UdyamRegistrationNumber'].touched && f['UdyamRegistrationNumber'].invalid" class="alert alert-danger required">
            <div *ngIf="f['UdyamRegistrationNumber'].errors && f['UdyamRegistrationNumber'].errors['required']">
              Udyam Number is required
            </div>

          </div>
        </div>



        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Name of Enterprise  <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" autocomplete="off" formControlName="EnterpriseName" trimValue id="txtEnterpriseName" class="form-control"
                 name="EnterpriseName" readonly style="background-color: #e9ecef; color: #6c757d;" />

          <div *ngIf="f['EnterpriseName'].touched && f['EnterpriseName'].invalid" class="alert alert-danger required">
            <div *ngIf="f['EnterpriseName'].errors && f['EnterpriseName'].errors['required']">
              Enterprise Name is required
            </div>
            <div *ngIf="f['EnterpriseName'].errors && f['EnterpriseName'].errors['minlength']">
              Minimum length should be 3 characters
            </div>
            <div *ngIf="f['EnterpriseName'].errors && f['EnterpriseName'].errors['pattern']">
              Enterprise name must not start with number or "&#64;+-=&".
            </div>
          </div>
        </div>




        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Name of Authorized Person <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" autocomplete="off" formControlName="AuthorizedPersonName" trimValue id="txtAuthorizedPersonName" class="form-control"
                 name="AuthorizedPersonName" readonly style="background-color: #e9ecef; color: #6c757d;" />

          <div *ngIf="f['AuthorizedPersonName'].touched && f['AuthorizedPersonName'].invalid" class="alert alert-danger required">
            <div *ngIf="f['AuthorizedPersonName'].errors && f['AuthorizedPersonName'].errors['required']">
              Authorised Person Name is required
            </div>
          </div>
        </div>
      </div>


      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">
        <div class="col-md-4" style=" flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Gender  <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" autocomplete="off" formControlName="Gender" trimValue id="txtGender" class="form-control"
                 name="Gender" readonly maxlength="19" style="background-color: #e9ecef; color: #6c757d;" />
          <div *ngIf="f['Gender'].touched && f['Gender'].invalid" class="alert alert-danger required">
            <div *ngIf="f['Gender'].errors && f['Gender'].errors['required']">
              Gender is required
            </div>

          </div>
        </div>



        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Social Category  <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" autocomplete="off" formControlName="SocialCategory" trimValue id="txtSocialCategory" class="form-control"
                 name="SocialCategory" readonly style="background-color: #e9ecef; color: #6c757d;" />

          <div *ngIf="f['SocialCategory'].touched && f['SocialCategory'].invalid" class="alert alert-danger required">
            <div *ngIf="f['SocialCategory'].errors && f['SocialCategory'].errors['required']">
              SocialCategory is required
            </div>

          </div>
        </div>




        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Enterprise Type <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" autocomplete="off" formControlName="EnterpriseType" trimValue id="txtEnterpriseType" class="form-control"
                 name="EnterpriseType" readonly style="background-color: #e9ecef; color: #6c757d;" />

          <div *ngIf="f['EnterpriseType'].touched && f['EnterpriseType'].invalid" class="alert alert-danger required">
            <div *ngIf="f['EnterpriseType'].errors && f['EnterpriseType'].errors['required']">
              EnterpriseType is required
            </div>
          </div>
        </div>
      </div>



      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">
        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Mobile Number <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="MobileNumber" maxlength="10">
          <div *ngIf="f['MobileNumber'].touched && f['MobileNumber'].invalid" class="alert alert-danger required">
            <div *ngIf="f['MobileNumber'].errors && f['MobileNumber'].errors['required']">
              Mobile Number is required
            </div>
            <div *ngIf="f['MobileNumber'].errors && f['MobileNumber'].errors['minlength']">
              Minimum length should be 10 characters
            </div>
            <div *ngIf="f['MobileNumber'].errors && f['MobileNumber'].errors['pattern']">
              Enter numbers only
            </div>
          </div>
        </div>


        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Email ID <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" autocomplete="off" id="txtEmailID" class="form-control"
                 formControlName="EmailID" trimValue placeholder="Enter  Email" maxlength="100">
          <div *ngIf="f['EmailID'].touched && f['EmailID'].invalid">
            <div *ngIf="f['EmailID'].errors && f['EmailID'].errors['required']" class="alert alert-danger required">
              Email is requried
            </div>
            <div *ngIf="f['EmailID'].errors?.['pattern']" class="alert alert-danger required">
              Invalid email format
            </div>
          </div>
        </div>




        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <!--<label>Date of Establishment <span class="text-danger">*</span></label>-->
          <!--<input type="date" class="form-control" />-->
          <!--<input class="form-control DateOfEstablishment" matInput
      [matDatepicker]="establishmentPicker"

      formControlName="DateOfEstablishment"
      (focus)="establishmentPicker.open()"
      readonly />-->
          <!--[value]="DateOfEstablishment | date: 'dd/MM/yyyy'"-->
          <!--<mat-datepicker-toggle matSuffix [for]="incorporationPicker"></mat-datepicker-toggle>-->
          <!--<mat-datepicker #establishmentPicker></mat-datepicker>-->
          <!-- Validation error messages -->
          <!--<div *ngIf="f['DateOfEstablishment'].errors && f['DateOfEstablishment'].errors['required']" class="text-danger">
        Date of Establishment is required
      </div>-->

          <label for="DateOfEstablishment" style="display: inline-block;">Date of Establishment <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="date" class="form-control" id="DateOfEstablishment" formControlName="DateOfEstablishment" [readonly]="isVerified" style="background-color: #e9ecef; color: #6c757d;" />

          <!-- Validation error messages -->
          <!--<div *ngIf="f['DateOfEstablishment'].errors?.['required']" class="text-danger">
        Date of Establishment is required
      </div>-->
          <div *ngIf="f['DateOfEstablishment'].touched && f['DateOfEstablishment'].invalid">
            <div *ngIf="f['DateOfEstablishment'].errors && f['DateOfEstablishment'].errors['required']" class="alert alert-danger required">
              Date is requried
            </div>
          </div>
        </div>

      </div>

      <h5 style="background-color: #6c757d; color: #fff; padding: 7px; border-radius: 5px; margin-top: revert;">Address For Rental Subsidy</h5>
      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">
        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Operational Address of Enterprise <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span> <br><small class="text-muted">(Address should be that for which rental subsidy is applied)</small></label>
          <textarea cols="5" rows="2" class="form-control" id="PresentAddress" formControlName="PresentAddress"
                    name="PresentAddress"></textarea>
          <div *ngIf="f['PresentAddress'].touched && f['PresentAddress'].invalid">
            <div *ngIf="f['PresentAddress'].errors?.['required']" class="alert alert-danger">
              Address is required.
            </div>
            <!--<div *ngIf="f['PresentAddress'].errors?.['pattern']" class="alert alert-danger">
          Address must not contain '&' character and should not start with "&#64;+-=".
        </div>
        <div *ngIf="f['PresentAddress'].errors?.['minlength']" class="alert alert-danger">
          Address must be at least 3 characters long.
        </div>
        <div *ngIf="f['PresentAddress'].errors?.['maxlength']" class="alert alert-danger">
          Address cannot exceed 300 characters.
        </div>-->
          </div>
        </div>

        <!--<div class="col-md-4 mt-4" style="flex: 0 0 auto; width: 33.33333333%;">
    <label for="distric">District<span class="text-danger">*</span></label>-->
        <!--<ng-select bindLabel="districtName"
               bindValue="districtId"
               formControlName="District"
               [searchable]="true"
               placeholder="--select--"
               [items]="districtsBasedOnState">
    </ng-select>-->
        <!--<ng-select bindLabel="districtName"
                 bindValue="districtId"
                 formControlName="DistrictId"
                 [searchable]="true"
                 placeholder="--select--"
                 [items]="districtsBasedOnState"
                 (change)="onDistrictSelected($event)">
      </ng-select>

      <div *ngIf="f['DistrictId'].invalid && isSubmitted" class="alert alert-danger required">
        <div *ngIf="f['DistrictId'].errors && f['DistrictId'].errors['required']">
          You must select an option.
        </div>
      </div>
    </div>-->

        <div class="col-md-4 mt-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label for="distric">District<span class="text-danger">*</span></label>

          <ng-select bindLabel="districtName"
                     bindValue="districtId"
                     formControlName="DistrictId"
                     [searchable]="true"
                     placeholder="--select--"
                     [items]="districtsBasedOnState"
                     (change)="onDistrictSelected($event)">
          </ng-select>

          <div *ngIf="f['DistrictId'].invalid && isSubmitted" class="alert alert-danger required">
            <div *ngIf="f['DistrictId'].errors && f['DistrictId'].errors['required']">
              You must select an option.
            </div>
          </div>
        </div>


        <div class="col-md-4 mt-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Pin Code<span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" id="pin" class="form-control" (keypress)="pinnumberOnly($event)" formControlName="Pin" />

          <div *ngIf="f['Pin']?.errors?.['required'] && f['Pin']?.touched" class="alert alert-danger">
            Pin Code is required.
          </div>
          <div *ngIf="f['Pin'].errors && f['Pin'].errors['pattern']" class="alert alert-danger">
            Enter numbers only
          </div>
        </div>


      </div>
      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">

        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">
            Rent Agreement <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
            <small class="text-muted">(PDF - File size should be less than 5MB)</small>
          </label>
          <input class="form-control" type="file" (change)="onRentAgreementFileSelected($event)" formControlName="RentAgreementFile" />

          <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('RentAgreementName')?.value }}</label>

          <div *ngIf="form.get('RentAgreementName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
            Rent Agreement File is required.
          </div>

          <div *ngIf="RentAgreementErrors?.typeError" class="alert alert-danger required">
            Invalid file type. Only PDF files are allowed.
          </div>
          <div *ngIf="RentAgreementErrors?.sizeError" class="alert alert-danger required">
            Rent Agreement File size exceeds the 5MB limit.
          </div>
        </div>


        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Area of current space in Sq.Ft <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" class="form-control" id="AreaOfCurrentSpace" formControlName="AreaOfCurrentSpace"
                 (keypress)="numberandDotOnly($event)" name="AreaOfCurrentSpace" />

          <div *ngIf="f['AreaOfCurrentSpace'].touched && f['AreaOfCurrentSpace'].invalid">
            <div *ngIf="f['AreaOfCurrentSpace'].errors?.['required']" class="alert alert-danger">
              Area of current space is required.
            </div>
            <div *ngIf="f['AreaOfCurrentSpace'].errors?.['pattern']" class="alert alert-danger">
              Please enter a valid number (e.g., 100, 50.5).
            </div>

          </div>
        </div>
        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Rent Frequency <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <select id="rentFrequency" class="form-select" formControlName="RentFrequency">
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="annually">Annually</option>
          </select>

          <div *ngIf="f['RentFrequency']?.invalid && f['RentFrequency']?.touched" class="text-danger mt-1">
            <div *ngIf="f['RentFrequency'].errors?.['required']" class="alert alert-danger">
              Rent Frequency is required.
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">



        <div class="col-md-4 mt-5" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Current Rent Paid <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" id="currentRentPaid" (keypress)="numberandDotOnly($event)" class="form-control" formControlName="CurrentRentPaid" />

          <div *ngIf="f['CurrentRentPaid']?.invalid && f['CurrentRentPaid']?.touched" class="text-danger mt-1">

            <div *ngIf="f['CurrentRentPaid'].errors?.['required'] && f['CurrentRentPaid']?.touched" class="alert alert-danger">
              Current Rent Paid is required.
            </div>
            <div *ngIf="f['CurrentRentPaid'].errors && f['CurrentRentPaid'].errors['pattern']" class="alert alert-danger">
              Enter numbers only
            </div>
          </div>

        </div>


        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">
            Upload Last Two Rent Payment Receipts <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
            <br><small class="text-muted">(Please merge 2 rent receipts)</small><br><small class="text-muted">(PDF - File size should be less than 5MB)</small>
          </label>

          <input id="UploadLastTwoRentPaymentReceiptsFiles" class="form-control" type="file" (change)="onUploadLastTwoRentPaymentReceiptsFileSelected($event)" formControlName="UploadLastTwoRentPaymentReceiptsFile" />

          <!-- This label displays the filename once a file has been selected. -->
          <!-- It's bound to the LastTwoRentName form control, which you provided. -->
          <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('UploadLastTwoRentPaymentReceiptsName')?.value }}</label>

          <!-- This block displays the 'required' error message. -->
          <!-- It assumes your form group is named 'form' and you have a property 'isSubmitted'. -->
          <div *ngIf="form.get('UploadLastTwoRentPaymentReceiptsName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
            Last Two Rent Payment Receipts is required.
          </div>

          <!-- This block displays a file type error. -->
          <!-- It assumes you have a component property named 'lastTwoRentErrors'. -->
          <div *ngIf="UploadLastTwoRentPaymentReceiptsErrors?.typeError" class="alert alert-danger required">
            Invalid file type. Only PDF files are allowed.
          </div>

          <!-- This block displays a file size error. -->
          <!-- It also assumes you have a component property named 'lastTwoRentErrors'. -->
          <div *ngIf="UploadLastTwoRentPaymentReceiptsErrors?.sizeError" class="alert alert-danger required">
            Last Two Rent Payment Receipts file size exceeds the 5MB limit.
          </div>
        </div>
        <div class="col-md-4 mt-5" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">Number of Employees on fulltime basis <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="number" id="numberOfEmployees" class="form-control" (keypress)="numberOnly($event)" formControlName="NumberOfEmployees" />


          <!-- The messages will only appear if the control is invalid and the user has interacted with it. -->
          <div *ngIf="f['NumberOfEmployees']?.invalid && f['NumberOfEmployees']?.touched" class="text-danger mt-1">
            <div *ngIf="f['NumberOfEmployees'].errors?.['required']" class="alert alert-danger">
              Number of Employees is required.
            </div>
            <div *ngIf="f['NumberOfEmployees'].errors?.['pattern']" class="alert alert-danger">
              Please enter a valid number.
            </div>
            <div *ngIf="f['NumberOfEmployees'].errors?.['min']" class="alert alert-danger">
              Minimum number of employees must be 5.
            </div>
          </div>

        </div>
      </div>


      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">


        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">
            Self-Certification signed by the Head of Human
            Resources or Authorized Representative <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span><br>
            <small class="text-muted">(PDF - File size should be less than 5MB)</small>
          </label>
          <input id="selfCertificationFile" class="form-control" type="file" (change)="onSelfCertificationFileSelected($event)" formControlName="SelfCertificationFile" />

          <!-- This label displays the filename once a file has been selected -->
          <label class="mb-2" style="display: inline-block; margin-bottom:12px">{{ form.get('SelfCertificationName')?.value }}</label>

          <!-- Displays the 'required' validation message -->
          <div *ngIf="form.get('SelfCertificationName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
            Self Certification File is required.
          </div>

          <!-- Displays a file type validation message -->
          <!-- This assumes you have a component property 'selfCertificationErrors' to track errors -->
          <div *ngIf="SelfCertificationErrors?.typeError" class="alert alert-danger required">
            Invalid file type. Only PDF files are allowed.
          </div>

          <!-- Displays a file size validation message -->
          <!-- This also assumes you have a component property 'selfCertificationErrors' to track errors -->
          <div *ngIf="SelfCertificationErrors?.sizeError" class="alert alert-danger required">
            Self Certification File size exceeds the 5MB limit.
          </div>

        </div>
      </div>

      <h5 class="mt-4" style="background-color: #dc3545; color: #fff; padding: 7px; border-radius: 5px; margin-top: 1.5rem !important;">2. Product Details <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></h5>
      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">
        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <!--<label>Sector <span class="text-danger">*</span></label>

      <input type="text" id="sector" class="form-control" formControlName="Sector" />

      <div *ngIf="f['Sector']?.errors?.['required'] && f['Sector']?.touched" class="text-danger mt-1">
        Sector is required.
      </div>-->

          <label style="display: inline-block;">Sector <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" id="sector" class="form-control" formControlName="Sector" readonly style="background-color: #e9ecef; color: #6c757d;" />

          <div *ngIf="f['Sector']?.invalid && f['Sector']?.touched" class="text-danger mt-1">
            <div *ngIf="f['Sector'].errors?.['required']" class="alert alert-danger">
              Sector is required.
            </div>
          </div>

        </div>

        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">
            Present Product <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
            <small class="text-muted">(PDF - File size should be less than 5MB)</small>
          </label>

          <input id="presentProductFile" class="form-control" type="file" (change)="onPresentProductFileSelected($event)" formControlName="PresentProductFile" />

          <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('PresentProductName')?.value }}</label>

          <!-- This block displays the 'required' error message. -->
          <!-- It assumes your form group is named 'form' and you have a property 'isSubmitted'. -->
          <div *ngIf="form.get('PresentProductName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
            Present Product file is required.
          </div>

          <!-- This block displays a file type error. -->
          <!-- It assumes you have a component property named 'presentProductErrors' to track this. -->
          <div *ngIf="PresentProductErrors?.typeError" class="alert alert-danger required">
            Invalid file type. Only PDF files are allowed.
          </div>

          <!-- This block displays a file size error. -->
          <!-- It also assumes you have a component property named 'presentProductErrors' to track this. -->
          <div *ngIf="PresentProductErrors?.sizeError" class="alert alert-danger required">
            Present Product file size exceeds the 5MB limit.
          </div>

        </div>


        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">NIC Code <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text" id="nicCode" class="form-control" formControlName="NICCode" readonly style="background-color: #e9ecef; color: #6c757d;" />

          <div *ngIf="f['NICCode']?.errors?.['required'] && f['NICCode']?.touched" class="text-danger mt-1">
            NIC Code is required.
          </div>
        </div>
      </div>
      <h5 class="mt-4" style="background-color: #dc3545; color: #fff; padding: 7px; border-radius: 5px; margin-top: 1.5rem !important;">3. Legal Information <span class="text-danger">*</span></h5>
      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">
        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">
            Udyam Certificate <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
            <small class="text-muted">(PDF - File size should be less than 5MB)</small>
          </label>
          <input id="udyamCertificateFile" class="form-control" type="file" (change)="onUdyamCertificateFileSelected($event)" formControlName="UdyamCertificateFile" />

          <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('UdyamCertificateName')?.value }}</label>


          <div *ngIf="form.get('UdyamCertificateName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
            Udyam Certificate file is  required.
          </div>

          <!-- This block displays a file type error. -->
          <!-- It assumes you have a component property named 'udyamCertificateErrors' to track this. -->
          <div *ngIf="UdyamCertificateErrors?.typeError" class="alert alert-danger required">
            Invalid file type. Only PDF files are allowed.
          </div>

          <!-- This block displays a file size error. -->
          <!-- It also assumes you have a component property named 'udyamCertificateErrors' to track this. -->
          <div *ngIf="UdyamCertificateErrors?.sizeError" class="alert alert-danger required">
            Udyam Certificate file size exceeds the 5MB limit.
          </div>

        </div>

        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">PAN Card Number <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span></label>
          <input type="text"
                 class="form-control"
                 id="panCardNumber"
                 formControlName="PanCardNumber"
                 placeholder="Enter PAN"
                 maxlength="10" />
          <!--(input)="onInputPan($event)"-->
          <div *ngIf="f['PanCardNumber'].touched && f['PanCardNumber'].invalid" class="alert alert-danger required">
            <div *ngIf="f['PanCardNumber'].errors && f['PanCardNumber'].errors['required']">
              Organisation PAN  is required
            </div>
            <div *ngIf="f['PanCardNumber'].errors && f['PanCardNumber'].errors['minlength']">
              Length should be 10 characters
            </div>
            <div *ngIf="f['PanCardNumber'].errors && f['PanCardNumber'].errors['pattern']">
              Enter proper PAN only
            </div>
          </div>

        </div>
        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">
            Upload PAN Card <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
            <small class="text-muted">(PDF - File size should be less than 5MB)</small>
          </label>
          <input id="panFile"
                 class="form-control"
                 type="file"
                 (change)="onPanFileSelected($event)"
                 formControlName="PanCardNumberFile" />

          <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('PanCardNumberName')?.value }}</label>

          <!-- This block displays the 'required' error message. -->
          <!-- It assumes your form group is named 'form' and you have a property 'isSubmitted'. -->
          <div *ngIf="form.get('PanCardNumberName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
            PAN Card is required.
          </div>

          <!-- This block displays a file type error. -->
          <!-- It assumes you have a component property named 'panErrors' to track this. -->
          <div *ngIf="PanCardNumberErrors?.typeError" class="alert alert-danger required">
            Invalid file type. Only PDF files are allowed.
          </div>

          <!-- This block displays a file size error. -->
          <!-- It also assumes you have a component property named 'panErrors' to track this. -->
          <div *ngIf="PanCardNumberErrors?.sizeError" class="alert alert-danger required">
            PAN Card file size exceeds the 5MB limit.
          </div>
        </div>
      </div>
      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">
        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">GST Registration No.</label>
          <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off" formControlName="GSTRegistrationNumber" trimValue id="txtGSTRegistrationNumber" class="form-control"
                 name="GSTRegistrationNumber" placeholder="GST Number" maxlength="15" />
          <div *ngIf="form.get('GSTRegistrationNumber')?.touched && f['GSTRegistrationNumber'].invalid" class="alert alert-danger required">
            <!--<div *ngIf="f['GSTRegistrationNumber'].errors && f['GSTRegistrationNumber'].errors['required']">
          GST Number  is required
        </div>-->
            <div *ngIf="f['GSTRegistrationNumber'].errors && f['GSTRegistrationNumber'].errors['minlength']">
              Minimum length should be 15 characters.
            </div>
            <div *ngIf="f['GSTRegistrationNumber'].errors && f['GSTRegistrationNumber'].errors['pattern']">
              Enter proper GST number only.
              First Two Characters (2 digits): Represents the state code as per the Indian Census.For example, 27 for Maharashtra, 10 for Bihar, etc.
              Next Ten Characters (10 digits): Represents the PAN (Permanent Account Number) of the business entity.
              Next Character (1 digit): Represents the entity number of the Pan holder
              Next Character (1 character): Represents the entity type:Z: Default value.
              Last Character (1 digit): Represents the either number or alphabet
            </div>
          </div>
          <!--<div *ngIf="panNotInGst" class="alert alert-danger required">
        PAN should be a part of the GST Number.
      </div>-->
        </div>


        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">
            Upload GST Registration Certificate <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
            <small class="text-muted">(PDF - File size should be less than 5MB)</small>
          </label>
          <input id="gSTRegistrationCertificateFile"
                 class="form-control"
                 type="file"
                 (change)="onGstFileSelected($event)"
                 formControlName="GSTRegistrationCertificateFile" />

          <!-- This label displays the filename once a file has been selected. -->
          <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('GSTRegistrationCertificateName')?.value }}</label>

          <!-- This block displays the 'required' error message. -->
          <!-- It assumes your form group is named 'form' and you have a property 'isSubmitted'. -->
          <div *ngIf="form.get('GSTRegistrationCertificateName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
            GST Registration Certificate is required.
          </div>

          <!-- This block displays a file type error. -->
          <!-- It assumes you have a component property named 'gstErrors' to track this. -->
          <div *ngIf="GSTRegistrationCertificateErrors?.typeError" class="alert alert-danger required">
            Invalid file type. Only PDF files are allowed.
          </div>

          <!-- This block displays a file size error. -->
          <!-- It also assumes you have a component property named 'gstErrors' to track this. -->
          <div *ngIf="GSTRegistrationCertificateErrors?.sizeError" class="alert alert-danger required">
            GST Registration Certificate file size exceeds the 5MB limit.
          </div>

        </div>


        <div class="col-md-4" style="flex: 0 0 auto; width: 33.33333333%;">
          <label style="display: inline-block;">
            Upload Proof - CPCB Category <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
            <small class="text-muted">(PDF - File size should be less than 5MB)</small>
          </label>
          <input id="cpcbFile"
                 class="form-control"
                 type="file"
                 (change)="onCPCBFileSelected($event)"
                 formControlName="CPCBFile" />
          <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('CPCBName')?.value }}</label>

          <!-- This block displays the 'required' error message. -->
          <!-- It assumes your form group is named 'form' and you have a property 'isSubmitted'. -->
          <div *ngIf="form.get('CPCBName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
            CPCB Category proof is required.
          </div>

          <!-- This block displays a file type error. -->
          <!-- It assumes you have a component property named 'cpcbCategoryErrors' to track this. -->
          <div *ngIf="CPCBErrors?.typeError" class="alert alert-danger required">
            Invalid file type. Only PDF files are allowed.
          </div>

          <!-- This block displays a file size error. -->
          <!-- It also assumes you have a component property named 'cpcbCategoryErrors' to track this. -->
          <div *ngIf="CPCBErrors?.sizeError" class="alert alert-danger required">
            CPCB Category proof file size exceeds the 5MB limit.
          </div>
        </div>
      </div>

      <!--added by rounak patil 17-12-2025-->
      <div class="alert alert-warning mt-2 mb-3" role="alert">
        <strong style="color:red">* Note:</strong>
        MSMEs for which five years of turnover documents are not applicable must upload a
        <strong>self-declaration on their official letterhead</strong>, specifying the
        <strong>year-wise turnover for all years since establishment</strong>.
      </div>

      <!--added by rounak patil 17-12-2025-->
      <h5 class="mt-4" style="background-color: #dc3545; color: #fff; padding: 7px; border-radius: 5px; margin-top: 1.5rem !important;">4. Financial Year - Turnover and Net Worth (INR crore)</h5>

      <div class="row mt-4" style="margin-top: 1.5rem !important; --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: calc(-1 * var(--bs-gutter-y)); margin-right: calc(-.5 * var(--bs-gutter-x)); margin-left: calc(-.5 * var(--bs-gutter-x)); ">
        <div class="col-md-12" style="flex: 0 0 auto; width: 100%;">
          <div class="table-responsive" style="overflow-x: auto; -webkit-overflow-scrolling: touch;">
            <table class="table table-bordered table-hover align-middle text-center" style="text-align: center !important; vertical-align: middle !important; --bs-table-color-type: initial; --bs-table-bg-type: initial; --bs-table-color-state: initial; --bs-table-bg-state: initial; --bs-table-color: var(--bs-emphasis-color); --bs-table-bg: var(--bs-body-bg); --bs-table-border-color: var(--bs-border-color); --bs-table-accent-bg: transparent; --bs-table-striped-color: var(--bs-emphasis-color); --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05); --bs-table-active-color: var(--bs-emphasis-color); --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1); --bs-table-hover-color: var(--bs-emphasis-color); --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075); width: 100%; margin-bottom: 1rem; vertical-align: top; border-color: var(--bs-table-border-color); caption-side: bottom; border-collapse: collapse; ">
              <thead class="table-dark" style=" --bs-table-color: #fff; --bs-table-bg: #212529; --bs-table-border-color: #4d5154; --bs-table-striped-bg: #2c3034; --bs-table-striped-color: #fff; --bs-table-active-bg: #373b3e; --bs-table-active-color: #fff; --bs-table-hover-bg: #323539; --bs-table-hover-color: #fff; color: var(--bs-table-color); border-color: var(--bs-table-border-color);">
                <tr>
                  <th>Fin_Year</th>
                  <th>2020-21</th>
                  <th>2021-22</th>
                  <th>2022-23</th>
                  <th>2023-24</th>
                  <th>2024-25</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Turnover</td>
                  <td>
                    <input type="text" class="form-control" id="TurnoverFY2020_21" name="TurnoverFY2020_21" formControlName="TurnoverFY2020_21"
                           placeholder="Enter Turnover for 2020-21" (keypress)="numberandDotOnly($event)" />
                    <div *ngIf="f['TurnoverFY2020_21'].touched && f['TurnoverFY2020_21'].invalid">
                      <!-- Displays if the field is empty and has been touched -->
                      <div *ngIf="f['TurnoverFY2020_21'].errors?.['required']" class="alert alert-danger">
                        Turnover FY2020-21 is required.
                      </div>
                      <!-- Displays if the input value does not match the decimal pattern -->
                      <div *ngIf="f['TurnoverFY2020_21'].errors?.['pattern']" class="alert alert-danger">
                        Turnover must be a numeric value.
                      </div>
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" id="TurnoverFY2021_22" name="TurnoverFY2021_22" formControlName="TurnoverFY2021_22"
                           placeholder="Enter Turnover for 2021-22" (keypress)="numberandDotOnly($event)" />
                    <div *ngIf="f['TurnoverFY2021_22'].touched && f['TurnoverFY2021_22'].invalid">
                      <!-- Displays if the field is empty and has been touched -->
                      <div *ngIf="f['TurnoverFY2021_22'].errors?.['required']" class="alert alert-danger">
                        Turnover FY2021-22 is required.
                      </div>
                      <!-- Displays if the input value does not match the decimal pattern -->
                      <div *ngIf="f['TurnoverFY2021_22'].errors?.['pattern']" class="alert alert-danger">
                        Turnover must be a numeric value.
                      </div>
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" id="TurnoverFY2022_23" name="TurnoverFY2022_23" formControlName="TurnoverFY2022_23"
                           placeholder="Enter Turnover for 2022-23" (keypress)="numberandDotOnly($event)" />
                    <div *ngIf="f['TurnoverFY2022_23'].touched && f['TurnoverFY2022_23'].invalid">
                      <!-- Displays if the field is empty and has been touched -->
                      <div *ngIf="f['TurnoverFY2022_23'].errors?.['required']" class="alert alert-danger">
                        Turnover FY2022-23 is required.
                      </div>
                      <!-- Displays if the input value does not match the decimal pattern -->
                      <div *ngIf="f['TurnoverFY2022_23'].errors?.['pattern']" class="alert alert-danger">
                        Turnover must be a numeric value.
                      </div>
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" id="TurnoverFY2023_24" name="TurnoverFY2023_24" formControlName="TurnoverFY2023_24"
                           placeholder="Enter Turnover for 2023-24" (keypress)="numberandDotOnly($event)" />
                    <div *ngIf="f['TurnoverFY2023_24'].touched && f['TurnoverFY2023_24'].invalid">
                      <!-- Displays if the field is empty and has been touched -->
                      <div *ngIf="f['TurnoverFY2023_24'].errors?.['required']" class="alert alert-danger">
                        Turnover FY2023-24 is required.
                      </div>
                      <!-- Displays if the input value does not match the decimal pattern -->
                      <div *ngIf="f['TurnoverFY2023_24'].errors?.['pattern']" class="alert alert-danger">
                        Turnover must be a numeric value.
                      </div>
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" id="TurnoverFY2024_25" name="TurnoverFY2024_25" formControlName="TurnoverFY2024_25"
                           placeholder="Enter Turnover for 2024-25" (keypress)="numberandDotOnly($event)" />
                    <div *ngIf="f['TurnoverFY2024_25'].touched && f['TurnoverFY2024_25'].invalid">
                      <!-- Displays if the field is empty and has been touched -->
                      <div *ngIf="f['TurnoverFY2024_25'].errors?.['required']" class="alert alert-danger">
                        Turnover FY2024-25 is required.
                      </div>
                      <!-- Displays if the input value does not match the decimal pattern -->
                      <div *ngIf="f['TurnoverFY2024_25'].errors?.['pattern']" class="alert alert-danger">
                        Turnover must be a numeric value.
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Upload</td>
                  <td>
                    <label style="display: inline-block;">
                      Upload Proof - FY 2020-21 <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
                      <small class="text-muted">(PDF - File size should be less than 5MB)</small>
                    </label>
                    <input id="FY2020_21_File"
                           class="form-control"
                           type="file"
                           (change)="onFY2020_21FileSelected($event)"
                           formControlName="FY2020_21_File" />
                    <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('FY2020_21_Name')?.value }}</label>

                    <!-- Required validation error message -->
                    <!-- The `form` group is used here based on the reference code. -->
                    <div *ngIf="form.get('FY2020_21_Name')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                      FY 2020-21 proof is required.
                    </div>
                    <!-- File type validation error message -->
                    <!-- This assumes you have a component property named 'FY2020_21Errors' to track errors. -->
                    <div *ngIf="FY2020_21_Errors?.typeError" class="alert alert-danger required">
                      Invalid file type. Only PDF files are allowed.
                    </div>

                    <!-- File size validation error message -->
                    <!-- This also assumes you have a component property named 'FY2020_21Errors' to track errors. -->
                    <div *ngIf="FY2020_21_Errors?.sizeError" class="alert alert-danger required">
                      FY 2020-21 proof file size exceeds the 5MB limit.
                    </div>
                  </td>
                  <td>
                    <!--<input type="file" class="form-control" />-->

                    <label style="display: inline-block;">
                      Upload Proof - FY 2021-22 <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
                      <small class="text-muted">(PDF - File size should be less than 5MB)</small>
                    </label>
                    <input id="FY2021_22_File"
                           class="form-control"
                           type="file"
                           (change)="onFY2021_22FileSelected($event)"
                           formControlName="FY2021_22_File" />
                    <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('FY2021_22_Name')?.value }}</label>

                    <!-- Required validation error message -->
                    <!-- The `form` group is used here based on the reference code. -->
                    <div *ngIf="form.get('FY2021_22_Name')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                      FY 2021-22 proof is required.
                    </div>
                    <!-- File type validation error message -->
                    <!-- This assumes you have a component property named 'FY2021_22Errors' to track errors. -->
                    <div *ngIf="FY2021_22_Errors?.typeError" class="alert alert-danger required">
                      Invalid file type. Only PDF files are allowed.
                    </div>

                    <!-- File size validation error message -->
                    <!-- This also assumes you have a component property named 'FY2021_22Errors' to track errors. -->
                    <div *ngIf="FY2021_22_Errors?.sizeError" class="alert alert-danger required">
                      FY 2021-22 proof file size exceeds the 5MB limit.
                    </div>
                  </td>
                  <td>
                    <!--<input type="file" class="form-control" />-->

                    <label style="display: inline-block;">
                      Upload Proof - FY 2022-23 <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
                      <small class="text-muted">(PDF - File size should be less than 5MB)</small>
                    </label>
                    <input id="FY2022_23_File"
                           class="form-control"
                           type="file"
                           (change)="onFY2022_23FileSelected($event)"
                           formControlName="FY2022_23_File" />
                    <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('FY2022_23_Name')?.value }}</label>

                    <!-- Required validation error message -->
                    <!-- The `form` group is used here based on the reference code. -->
                    <div *ngIf="form.get('FY2022_23_Name')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                      FY 2022-23 proof is required.
                    </div>
                    <!-- File type validation error message -->
                    <!-- This assumes you have a component property named 'FY2022_23Errors' to track errors. -->
                    <div *ngIf="FY2022_23_Errors?.typeError" class="alert alert-danger required">
                      Invalid file type. Only PDF files are allowed.
                    </div>

                    <!-- File size validation error message -->
                    <!-- This also assumes you have a component property named 'FY2022_23Errors' to track errors. -->
                    <div *ngIf="FY2022_23_Errors?.sizeError" class="alert alert-danger required">
                      FY 2022-23 proof file size exceeds the 5MB limit.
                    </div>
                  </td>
                  <td>
                    <!--<input type="file" class="form-control" />-->

                    <label style="display: inline-block;">
                      Upload Proof - FY 2023-24 <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
                      <small class="text-muted">(PDF - File size should be less than 5MB)</small>
                    </label>
                    <input id="FY2023_24_File"
                           class="form-control"
                           type="file"
                           (change)="onFY2023_24FileSelected($event)"
                           formControlName="FY2023_24_File" />
                    <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('FY2023_24_Name')?.value }}</label>

                    <!-- Required validation error message -->
                    <!-- The `form` group is used here based on the reference code. -->
                    <div *ngIf="form.get('FY2023_24_Name')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                      FY 2023-24 proof is required.
                    </div>
                    <!-- File type validation error message -->
                    <!-- This assumes you have a component property named 'FY2023_24Errors' to track errors. -->
                    <div *ngIf="FY2023_24_Errors?.typeError" class="alert alert-danger required">
                      Invalid file type. Only PDF  files are allowed.
                    </div>

                    <!-- File size validation error message -->
                    <!-- This also assumes you have a component property named 'FY2023_24Errors' to track errors. -->
                    <div *ngIf="FY2023_24_Errors?.sizeError" class="alert alert-danger required">
                      FY 2023-24 proof file size exceeds the 5MB limit.
                    </div>
                  </td>
                  <td>

                    <!--<input type="file" class="form-control" />-->

                    <label style="display: inline-block;">
                      Upload Proof - FY 2024-25 <span class="text-danger" style="--bs-text-opacity: 1; color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;">*</span>
                      <small class="text-muted">(PDF - File size should be less than 5MB)</small>
                    </label>
                    <input id="FY2024_25_File"
                           class="form-control"
                           type="file"
                           (change)="onFY2024_25FileSelected($event)"
                           formControlName="FY2024_25_File" />
                    <label class="mb-2" style="display: inline-block; margin-bottom: .5rem !important;">{{ form.get('FY2024_25_Name')?.value }}</label>

                    <!-- Required validation error message -->
                    <!-- The `form` group is used here based on the reference code. -->
                    <div *ngIf="form.get('FY2024_25_Name')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                      FY 2024-25 proof is required.
                    </div>
                    <!-- File type validation error message -->
                    <!-- This assumes you have a component property named 'FY2024_25Errors' to track errors. -->
                    <div *ngIf="FY2024_25_Errors?.typeError" class="alert alert-danger required">
                      Invalid file type. Only PDF files are allowed.
                    </div>

                    <!-- File size validation error message -->
                    <!-- This also assumes you have a component property named 'FY2024_25Errors' to track errors. -->
                    <div *ngIf="FY2024_25_Errors?.sizeError" class="alert alert-danger required">
                      FY 2024-25 proof file size exceeds the 5MB limit.
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <h5 class="mt-4" style="background-color: #dc3545; color: #fff; padding: 7px; border-radius: 5px; margin-top: 1.5rem !important;">5. Declaration</h5>
      <div class="form-check mt-4" style="margin-top: 1.5rem !important;">
        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" formControlName="isTermsConditionAccepted" required>
        <label class="form-check-label" for="flexCheckDefault" style="display: inline-block;">
          We confirm that our company/firm/enterprise <u><strong>{{form.get('EnterpriseName')?.value}}</strong></u> as on date of submission of this EoI is not blacklisted by any Central/State Government/PSU entity in India for any unsatisfactory past performance, corrupt, fraudulent or any other unethical business practices. We also confirm that the company /firm / enterprise is not banned or convicted by any court of law or declared ineligible for corrupt & fraudulent practices either indefinitely or for a particular period by any Government /PSU/ Autonomous Body (Under Any government law) in India.
        </label>

      </div>
      <div class="form-check mt-4" style="margin-top: 1.5rem !important;">
        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault1" formControlName="isAddlTermsConditionAccepted" required>
        <label class="form-check-label" for="flexCheckDefault1" style="display: inline-block;">
          <!--We confirm that our company/firm/enterprise <u><strong>{{form.get('EnterpriseName')?.value}}</strong></u> as on date of submission of this EoI is not blacklisted by any Central/State Government/PSU entity in India for any unsatisfactory past performance, corrupt, fraudulent or any other unethical business practices. We also confirm that the company /firm / enterprise is not banned or convicted by any court of law or declared ineligible for corrupt & fraudulent practices either indefinitely or for a particular period by any Government /PSU/ Autonomous Body (Under Any government law) in India.-->
          1. We confirm that all information and documents provided in this EoI are true, accurate, and complete.<br>
          2. We agree to provide any additional information the Corporation may require.<br>
          3. We understand that the Corporation may reject our EoI without giving a reason, and we accept this without objection.<br>
          4. We operate on rent in a space of <u><strong>{{form.get('AreaOfCurrentSpace')?.value}}</strong></u> sq. ft. at <u><strong>{{form.get('PresentAddress')?.value}}</strong></u><br>
          5. We declare that:<br>
          • We have reviewed the EoI and any updates without any objections.<br>
          • We have no conflict of interest.<br>
          • We have not been involved in any corrupt or unfair practices.<br>
          • We have not been blacklisted by any government body.<br>
          6. We understand the Department may cancel the EoI process at any time without obligation.<br>
          7. We confirm that no regulatory investigation is pending against us or our key personnel.<br>
          8. We hereby submit our EoI as per the terms outlined in the EoI document.<br>
        </label>
      </div>

      <div class="col-md-12 mt-4 text-center" style="caption-side: bottom; border-collapse: collapse; flex: 0 0 auto; width: 100%; margin-top: 1.5rem !important; ">
        <button type="submit" class="btn btn-success" (click)="onSubmit()" [disabled]="!form.get('isTermsConditionAccepted')?.value || !form.get('isAddlTermsConditionAccepted')?.value">Submit</button>
        <!--<button id="btnSave" type="submit" class="btn btn-success" (click)="onSubmit()"> Submit</button>-->
        <button id="btncancel" type="button" (click)="onReset()" class="btn btn-danger mx-3">Reset</button>
        <!--<button type="button" class="btn btn-danger">Cancel</button>-->
        <button id="btncancel" type="button" (click)="onCancel()" class="btn btn-danger mx-3">Cancel</button>
      </div>
    </form>
    <div class="loader-container" *ngIf="loadingSequence">
      <div class="three-strings">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="processing-text">Processing...</div>
    </div>
  </div>
</div>
<ng-template #warningDialog>
  <!--<h2 mat-dialog-title>Informative Messge</h2>-->
 <h2 style="padding-left:20px; margin-top:30px"> Information  <i class="fas fa-info-circle text-primary"></i></h2>
  <mat-dialog-content>
    Applicant entity must be operational for a maximum of 5 years as on the date of application. You have exceeded this date.
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</ng-template>

